export { pageViewTrackingPlugin } from './page-view-tracking';
export { pageViewTrackingPlugin as plugin } from './page-view-tracking';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amplitude/plugin-page-view-tracking-browser/lib/esm/index.js
// module id = 741
// module chunks = 1